import React, { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { Q_MAKE_VARIANT } from 'graphql/query'
import Divider from '@material-ui/core/Divider'
import Paper from '@material-ui/core/Paper'
import { useHistory, useRouteMatch } from 'react-router-dom'

import NewVariation from '../Forms/NewVariation'
import NewMake from '../Forms/NewMake'
import Loading from 'components/Global/Loading'
import styles from '../vehicle.module.scss'

const MakeVariant = ({ mdId, setVvrId }) => {
  const [makes, setMakes] = useState([])
  const [loading, setLoading] = useState(true)
  const update = () => {
    refetch() &&
      refetch().then(res => {
        setMakes(res.data.rVehicleModel[0].vehiclemakeSet)
        setLoading(false)
      })
  }
  const { refetch } = useQuery(Q_MAKE_VARIANT, {
    variables: {
      id: parseInt(mdId),
    },
  })

  useEffect(() => {
    update()
  }, [refetch])

  const history = useHistory()
  let { url } = useRouteMatch()

  const updateUrl = link => {
    history.push(link)
  }

  return !loading ? (
    <div className={styles.makeVariantWrapper}>
      {makes.map((make, i) => (
        <div key={i}>
          <div className={styles.makeFont}>
            {make.year === 0 ? 'default' : make.year}
          </div>
          <div className={styles.mvVariantWrapper}>
            {make.vehiclevariantSet.map((variation, i) => (
              <Paper
                className={styles.mvVariant}
                key={i}
                onClick={() => {
                  updateUrl(`${url}/${variation.id}`)
                }}
              >
                {variation.name === '__default__' ? 'default' : variation.name}
              </Paper>
            ))}
            <NewVariation
              makeId={parseInt(make.id)}
              update={update}
              loading={setLoading}
            />
          </div>
          <Divider />
        </div>
      ))}
      <NewMake modelId={mdId} loading={setLoading} update={update} />
    </div>
  ) : (
    <Loading />
  )
}
export default MakeVariant
